// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_3EaYL){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_2FAzc .dualColumn_2cEwF{display:flex;align-content:space-between}.nsAddressForm_2FAzc .dualColumn_2cEwF .firstCol_24qdS{margin-right:20px}.optional_deL4w{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_3EaYL",
	"nsAddressForm": "nsAddressForm_2FAzc",
	"dualColumn": "dualColumn_2cEwF",
	"firstCol": "firstCol_24qdS",
	"optional": "optional_deL4w"
};
module.exports = exports;
